import React, { useState, useEffect } from 'react';
import TokenService from 'services/TokenService';

const CountdownTimer = ({ expiresAt, onTimeUp }) => {
  const getTimeLeft = () => Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const updateTimeLeft = () => {
      const nextTimeLeft = getTimeLeft();
      setTimeLeft(nextTimeLeft);

      if (nextTimeLeft === 0 && onTimeUp) {
        onTimeUp();
      }
    };

    updateTimeLeft();
    const interval = setInterval(() => {
      updateTimeLeft();
    }, 1000);
    return () => clearInterval(interval);
  }, [expiresAt, onTimeUp]);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');

  return (
    <strong style={{ fontFamily: 'monospace' }}>{minutes}:{seconds}.</strong>
  );
};

const SessionWarningDetails = ({ expiresAt, onExtendSession, closeToast, onDismiss }) => {
  const dismiss = onDismiss || closeToast;

  useEffect(() => {
    const sub = TokenService.authDataChanges$.subscribe(authData => {
      if (!authData && dismiss) dismiss();
    });
    return () => sub.unsubscribe();
  }, [dismiss]);

  return (
    <div>
      Atenção. O tempo da sessão irá encerrar em <CountdownTimer expiresAt={expiresAt} onTimeUp={dismiss} />{" "}
      <span
        className="extend-session"
        onClick={onExtendSession}
        style={{ cursor: 'pointer' }}
      >
        {/* <strong><u>Clique aqui para reiniciar o tempo da sessão.</u></strong> */}
      </span>
    </div>
  );
};

export default SessionWarningDetails;
